import { z } from "zod";
import { modelInfoSchema } from "@shared/schemas/models";

export { modelInfoSchema, modelCapabilitiesSchema } from "@shared/schemas/models";
export type { ModelInfo, ModelCapabilities } from "@shared/schemas/models";

export const ModelInfoArraySchema = z.array(modelInfoSchema);
